var _line, _rect, _line2, _line3, _line4, _path, _circle, _line5, _line6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIndoorBaggageBelt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 16.607,
    y1: 2.885,
    x2: 25.393,
    y2: 2.885
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9.159,
    y: 15.453,
    width: 23.683,
    height: 21.181,
    rx: 2.636,
    ry: 2.636
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 21,
    y1: 2.885,
    x2: 21,
    y2: 14.325
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 13.67,
    y1: 36.633,
    x2: 13.67,
    y2: 39.115
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 28.33,
    y1: 36.633,
    x2: 28.33,
    y2: 39.115
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m23.554,31.707h-5.108c-1.462,0-2.648-1.186-2.648-2.648v-5.56c0-.593.268-1.155.729-1.529l4.474-3.628,4.474,3.628c.461.374.729.936.729,1.529v5.56c0,1.462-1.186,2.648-2.648,2.648Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 23.866,
    r: 0.542
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 15.899,
    y1: 22.884,
    x2: 9.159,
    y2: 22.884
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 32.841,
    y1: 22.884,
    x2: 26.202,
    y2: 22.884
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndoorBaggageBelt);
export default __webpack_public_path__ + "static/media/indoor-baggage_belt.0405672012e6affee25facc26c0b9df7.svg";
export { ForwardRef as ReactComponent };